import type { EChartsExtensionInstallRegisters, ExtensionAPI } from 'echarts';
import { prepareFlagInfoList, shiftLayoutOnY as shiftFlagLayoutOnY } from './FlagLayoutHelper';
import {
  getCurvedPointerLayoutListPrepareInput,
  prepareCurvedPointerInfoList,
  shiftLayoutOnY as shiftCurvedPointerLayoutOnY
} from './curvedPointerLayoutHelper';

function adjustFlagPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'flag');
  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridRect = markModel.coordinateSystem.master.getRect();
    const flagInfoList = prepareFlagInfoList(markView);
    shiftFlagLayoutOnY(flagInfoList, gridRect.y, gridRect.y + gridRect.height);
  });
}

function adjustCurvedPointerPosition(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const dvMarkerModel = ecModel
    .getSeriesByType('custom')
    .filter(
      item => item.option?.dvType === 'dvMarker' && item.option?.dvMarkType === 'curvedPointer'
    );
  dvMarkerModel.forEach(markModel => {
    const markView = chart.getViewOfSeriesModel(markModel);
    const gridRect = markModel.coordinateSystem.master.getRect();
    const input = getCurvedPointerLayoutListPrepareInput(markView);
    const curvedPointerInfoList = prepareCurvedPointerInfoList(input);
    shiftCurvedPointerLayoutOnY(curvedPointerInfoList, gridRect.y, gridRect.y + gridRect.height);
  });
}

export function dvMarkerExtensionInstall(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (_, chart) => {
    // todo目前为flag标记特有的位置调整扩展
    adjustFlagPosition(chart);
    adjustCurvedPointerPosition(chart);
  });
}
